/**
 * The storage prefix and the key naming rule, held apart from the Zod-backed wrapper so the
 * public entry can address a key without carrying the schema library
 * (`contracts/client-api.md` § Performance budgets). `local.ts` re-exports both.
 */
export const STORAGE_PREFIX = "baton";

export function storageName(name: string, scope?: string): string {
  return scope === undefined ? `${STORAGE_PREFIX}:${name}` : `${STORAGE_PREFIX}:${name}:${scope}`;
}
